(() => {
  const PRODUCT_IDS = {
    core: "10316215255377", // Kaiju -> 28 sticks
    kick: "10342454100305", // Kaiju Kick -> 12 sticks
    pack: "10448039706961", // Performance Pack -> ne pas afficher
  };

  const STICKS_BY_PRODUCT_ID = {
    [PRODUCT_IDS.core]: 28,
    [PRODUCT_IDS.kick]: 12,
  };

  const moneyTextToNumber = (str) => {
    const cleaned = (str || "")
      .replace(/\s/g, "")
      .replace(/[^\d,.-]/g, "")
      .replace(",", ".");
    const n = Number(cleaned);
    return Number.isFinite(n) ? n : null;
  };

  const round2 = (n) => Math.round(n * 100) / 100;

  const getAppstleModeAndPrice = (btn) => {
    const scope = btn.closest("form") || btn.closest(".shopify-section") || document;

    // radio Appstle checked (c’est ça la vérité)
    const checked = scope.querySelector('.appstle_sub_widget input[type="radio"][name="selling_plan"]:checked');
    const isOneTime = checked && String(checked.value || "").trim() === "";

    if (isOneTime) {
      // one-time : prix dans le wrapper one-time
      const oneTimePriceEl = scope.querySelector(
        ".appstle_one_time_price_wrapper .appstle_subscription_amount"
      );
      const oneTime = moneyTextToNumber(oneTimePriceEl?.textContent);
      return { mode: "onetime", price: oneTime };
    }

    // subscription : prix dans le wrapper subscription
    const subPriceEl = scope.querySelector(
      ".payAsYouGoPlansDropdownWrapper .appstle_subscription_amount_wrapper .appstle_subscription_amount"
    );
    const sub = moneyTextToNumber(subPriceEl?.textContent);
    return { mode: "subscription", price: sub };
  };

  const getFallbackPrice = (btn) => {
    const scope =
      btn.closest(".shopify-section") ||
      btn.closest("section") ||
      document;

    const el =
      scope.querySelector(".price .price-item--sale") ||
      scope.querySelector(".price .price-item--regular") ||
      scope.querySelector(".price__container .price-item") ||
      scope.querySelector(".product__info-container .price .price-item") ||
      null;

    const n = moneyTextToNumber(el?.textContent);
    return n != null ? n : null;
  };

  const updateAll = () => {
    document.querySelectorAll('button[id^="ProductSubmitButton-"]').forEach((btn) => {
      const perStickEl = btn.querySelector("[data-atc-perstick]");
      if (!perStickEl) return;

      const productId = String(perStickEl.getAttribute("data-product-id") || "");
      const sticksCount = STICKS_BY_PRODUCT_ID[productId];

      // pack / autres => cacher
      if (!sticksCount) {
        perStickEl.hidden = true;
        perStickEl.textContent = "";
        return;
      }

      // Appstle d’abord
      const { price: appstlePrice } = getAppstleModeAndPrice(btn);
      const price = appstlePrice != null ? appstlePrice : getFallbackPrice(btn);

      if (price == null) {
        perStickEl.hidden = true;
        perStickEl.textContent = "";
        return;
      }

      const perStick = round2(price / sticksCount).toFixed(2);
      const next = `(${perStick}€/stick)`;

      if (perStickEl.textContent !== next) perStickEl.textContent = next;
      if (perStickEl.hidden) perStickEl.hidden = false;
    });
  };

  let raf = null;
  const scheduleUpdate = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      updateAll();
    });
  };

  const init = () => {
    updateAll();

    // Appstle toggle = click + change
    document.addEventListener("click", scheduleUpdate);
    document.addEventListener("change", scheduleUpdate);
    document.addEventListener("input", scheduleUpdate);

    // observer safe + attributes (checked change)
    const obs = new MutationObserver(scheduleUpdate);
    obs.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["checked", "value", "class", "style", "hidden", "aria-hidden"],
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();